import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { commonLanguages } from "@app/translateLanguages";

interface ViewModel {
    form: FormGroup;
}

@Component({
    selector: 'app-export-subtitles',
    templateUrl: './export-subtitles.component.html',
    styleUrls: ['./export-subtitles.component.scss']
})
export class ExportSubtitlesComponent implements OnInit {
    viewModel: ViewModel;

    timing;
    type;
    types;
    public language: string;
    languages;
    lineLength;

    constructor(
        private ref: MatDialogRef<ExportSubtitlesComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit() {
        this.types = 
            [
                { label: 'VTT', value: 'vtt' },
                { label: 'SRT', value: 'srt' },
                { label: 'Plain', value: 'txt' }
            ];

        this.viewModel = {
            form: new FormGroup({
                type: new FormControl(),
                language: new FormControl(),
                timing: new FormControl(),
                lineLength: new FormControl()
            })
        }

        this.languages = commonLanguages.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        this.type = 'vtt';
        this.language = 'en';
        this.timing = 7;
        this.lineLength = 42;
    }

    async exportSubtitles() {
        this.ref.close({ type: this.type, language: this.language, timing: this.timing, lineLength: this.lineLength });
    }
}